import {get} from '../utils'

export default host => ({tagGroupType, contentCreatorType = null, tags, notTags, lastTagId}) =>
  get(`${host}/tags/${tagGroupType}${contentCreatorType ? `/${contentCreatorType}` : ''}?tags_ids=${tags.join(',')}&not_tags_ids=${notTags.join(',')}${lastTagId ? `&last_tag_id=${lastTagId}` : ''}`)
    .then(response => response.json())
    .then(json => json.data)
